export default "\r\n<router-outlet></router-outlet>\r\n<app-alert></app-alert>\r\n<app-preloader></app-preloader> \r\n"